import { useEffect } from 'react';

const useOnEscape = (handler) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        handler(e);
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [handler]);
};

export default useOnEscape;
